// extracted by mini-css-extract-plugin
export var relativeWrapper = "LetsTalk-module--relativeWrapper--148pa";
export var decor = "LetsTalk-module--decor--2lRRu";
export var container = "LetsTalk-module--container--2ST3F";
export var stickyContainer = "LetsTalk-module--stickyContainer--3M6Jx";
export var logoA = "LetsTalk-module--logoA--3VrV-";
export var mobile = "LetsTalk-module--mobile--3MJVc";